var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-badge',_vm._b({class:`q-ml-${_vm.marginLeft} q-mr-${_vm.marginRight}`},'q-badge',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }